module.exports = __webpack_public_path__ + "static/img/video1.cb41057.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentPhonePage/video1.png
// module id = 5iQm
// module chunks = 0